import { getNamedEnum } from './enum-helper';
import { TranslateService } from 'src/app/services/translate.service';

export function translateEnum<E extends Record<string, string | number>>(
    enumType: E,
    value: number | null | undefined,
    translateService: TranslateService,
    transform?: (name: string) => string
): string {
    if (value == null) return '-';
    const name = getNamedEnum(enumType)[value];
    if (!name) return '-';
    const transformedName = transform ? transform(name) : name;
    return translateService.getDynamicTranslation(transformedName);
}
